import { GET, LanguageContext, MetaContext, POST, QueryDetail, READWITH, TranslateContext, UserConfigContext, UserContext, errorCatch, useAuth } from "fennec-ui";
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import React from "react"
import { Layout, List, Spin } from 'antd';
import Icofont from "react-icofont";
import { useEffect } from "react";
import { useState } from "react";
import YImage from '../../../common/YImage';
import { LoadingOutlined } from '@ant-design/icons';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { LangSwitchContext } from "../../../common/Context";
import { translate } from "../../../common/Tool";
import REDUX_UserConfig from '../../../objects/UserConfig/reducer'
import REDUX_Translate from '../../../objects/Translate/reducer';
import { useDispatch, useSelector } from "react-redux";
import LangSwitch from "../../components/LangSwitch";
import FedHeader from "../FedHeader";
import { Content, Footer } from "antd/es/layout/layout";
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
var _ = require('lodash');
dayjs.locale('ru');

function Switcher(props) {
    const { event } = props;
    const auth = useAuth();
    const dispatch = useDispatch();
    const meta = useSelector(state => state.meta);
    const user = useSelector(state => state.home.user);
    const userConfig = useSelector(REDUX_UserConfig.selector.object) || {};
    const translates = useSelector(REDUX_Translate.selector.object);
    const [language, setLanguage] = useState({ lang: (auth.getCookie("lang") || "ru") })
    const t = React.useMemo(() => _.bind(translate, {
        translate: translates,
        config: language
    }), [translates, language]);
    // const t = useTranslateContext();
    // console.log(t("да"));

    const setUserConfig = (name, value, onChange) => {
        POST(auth, "/api/setuserconfig", {
            key: name,
            value: value
        }, ({ data }) => {
            var arr = [data];
            var obj = Object.fromEntries(arr.map(i => {
                return [
                    i.key,
                    i.value
                ]
            }));
            let i = { ...userConfig, ...obj };
            let o = REDUX_UserConfig.actions.setObject(i);
            dispatch(o);
            if (onChange) {
                onChange(i);
            }
        }, errorCatch);
    };

    useEffect(() => {
        READWITH(auth, 'Translate', [
            QueryDetail("model")
        ], ({ data }) => {
            if (data.length > 0) {
                let o = Object.fromEntries(data.map(i => {
                    return [
                        i.key,
                        {
                            ru: i.ru,
                            en: i.en,
                            es: i.es,
                            tr: i.tr,
                        },
                    ]
                }));
                dispatch(REDUX_Translate.actions.setObject(o));
            }
        }, errorCatch)
        READWITH(auth, 'UserConfig', [
            QueryDetail("model")
        ], ({ data }) => {
            if (data.length > 0) {
                var obj = Object.fromEntries(data.map(i => {
                    return [
                        i.key,
                        i.value
                    ]
                }));
                dispatch(REDUX_UserConfig.actions.setObject(obj));
            }
        }, errorCatch)
    }, []);

    return (
        <TranslateContext.Provider value={t}>
            <MetaContext.Provider value={meta}>
                <UserContext.Provider value={user}>
                    <UserConfigContext.Provider value={[userConfig, setUserConfig]}>
                        <LanguageContext.Provider value={[language, setLanguage]}>
                            <LangSwitchContext.Provider value={<LangSwitch userConfig={userConfig} />}>
                                <Layout>
                                    <FedHeader layout={"web"} hideLogo={true}>
                                        {/* <MenuOne menu={menu(status, notify)} /> */}
                                    </FedHeader>
                                    <Content style={{ padding: '6px' }}>
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingTop: "50px" /*, height:"100vh"*/ }}>
                                            <div style={{
                                                maxWidth: "300px",
                                                minWidth: "250px",
                                            }}>
                                                <div style={{ textAlign: "center", paddingBottom: "25px" }}>
                                                    <a href={auth.schemhttp + "://" + auth.getDomainWithoutSubdomain(window.location.href)}>
                                                        <img style={{ height: "70px" }} src="/resources/logo-blue.svg" alt="Logo" />
                                                    </a>
                                                </div>
                                                <div>
                                                    {event && <div style={{ textAlign: "center", paddingBottom: "15px" }}>
                                                        <YImage item={event} width={180} style={{ borderRadius: "4px" }} />
                                                        <div style={{ fontSize: "16px", paddingTop: "15px" }}>
                                                            <a href={`/fed/event/${event?.ID}`}>
                                                                {event?.nazvanieMeropriyatiya}
                                                            </a>
                                                        </div>
                                                        <div style={{ fontSize: "14px" }}>
                                                            {dayjs(event?.nachaloSorevnovaniya).format("DD.MM.YYYY")},  {_.get(event, "mestoProvedeniya.name")}
                                                        </div>
                                                    </div>}
                                                    <div style={{ textAlign: "center", paddingBottom: "15px" }}>{t("Выберите формат соревнования")}!</div>
                                                    <List>
                                                        <List.Item
                                                            style={{
                                                                padding: "4px 5px", margin: "5px 0",
                                                                borderLeft: "4px solid #e9e9e9"
                                                            }}
                                                            className={"bg bg-fwhite pointer"}>
                                                            <a style={{ textAlign: "left", fontSize: "13px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://jack.${auth.getDomainWithoutSubdomain(window.location.href)}${(event) ? "/event/" + event?.ID : ""}`}>
                                                                <div style={{ fontWeight: "bold", fontSize: "16px" }}>{t("Jack and Jill")}</div>
                                                                <div style={{ color: "#a3a3a3", fontSize: "13px" }}>
                                                                    {t("Соревнование! Судьи оценивают участников, соревнование по турам и заходам.")}
                                                                </div>
                                                            </a>
                                                        </List.Item>
                                                        <List.Item
                                                            style={{
                                                                padding: "4px 5px", margin: "5px 0",
                                                                borderLeft: "4px solid rgb(0, 29, 102)"
                                                            }}
                                                            className={"bg bg-fwhite pointer"}>
                                                            <a style={{ textAlign: "left", fontSize: "13px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://jam.${auth.getDomainWithoutSubdomain(window.location.href)}${(event) ? "/event/" + event?.ID : ""}`}>
                                                                <div style={{ fontWeight: "bold", fontSize: "16px" }}>{t("Jam")}</div>
                                                                <div style={{ color: "#a3a3a3", fontSize: "13px" }}>
                                                                    {t("Партнёры оценивают друг друга, без судей, соревнование по турам.")}
                                                                </div>
                                                            </a>
                                                        </List.Item>
                                                        <List.Item
                                                            style={{
                                                                padding: "4px 5px", margin: "5px 0",
                                                                borderLeft: "4px solid #f6214b"
                                                            }}
                                                            className={"bg bg-fwhite pointer"}>
                                                            <a style={{ textAlign: "left", fontSize: "13px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://party.${auth.getDomainWithoutSubdomain(window.location.href)}${(event) ? "/event/" + event?.ID : ""}`}>
                                                                <div style={{ fontWeight: "bold", fontSize: "16px" }}>{t("Party")}</div>
                                                                <div style={{ color: "#a3a3a3", fontSize: "13px" }}>
                                                                    {t("Вечеринка! Все танцуют с кем хотят и могут оценить партнера")}
                                                                </div>
                                                            </a>
                                                        </List.Item>
                                                    </List>
                                                </div>
                                                <div style={{ textAlign: "center" }}>
                                                    <div style={{ padding: "10px 0" }}>
                                                        <div className='line'><span style={{ backgroundColor: "transparent" }}>или</span></div>
                                                    </div>
                                                    <List>
                                                        <List.Item
                                                            style={{ padding: "4px 5px", margin: "5px 0" }}
                                                            // className={"bg bg-orange pointer"}
                                                            className={"bg bg-fwhite pointer"}>
                                                            <a style={{ width: "100%", fontSize: "13px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app`}>
                                                                <Icofont icon="home" style={{ fontSize: "13px", color: "orange" }} /> {t("Личный кабинет")}
                                                            </a>
                                                        </List.Item>
                                                        <List.Item
                                                            style={{ padding: "4px 5px", margin: "5px 0" }}
                                                            // className={"bg bg-blue pointer"}
                                                            className={"bg bg-fwhite pointer"}>
                                                            <a style={{ width: "100%", fontSize: "13px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/events`}>
                                                                <i className="fa fa-globe" style={{ paddingRight: "4px", color: "blue" }}></i> {t("Главный сайт")}
                                                            </a>
                                                        </List.Item>
                                                        {/* <List.Item
                            style={{ padding: "4px 5px" }}
                            // className={"bg bg-green pointer"}
                            className={"bg bg-fwhite pointer"}>
                            <a style={{ fontSize: "13px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://jack.${auth.getDomainWithoutSubdomain(window.location.href)}`}>
                                <Icofont icon="ui-calendar" style={{ fontSize: "13px", color: "green" }} /> {t("Войти в мероприятие")}
                            </a>
                        </List.Item>
                        <List.Item
                            style={{ padding: "4px 5px" }}
                            // className={"bg bg-grey pointer"}
                            className={"bg bg-fwhite pointer"}>
                            <a style={{ fontSize: "13px", color: "rgba(0,0,0,0.85)" }} href={`${auth.authschemhttp}://auth.${auth.getDomainWithoutSubdomain(window.location.href)}/common/profile`}>
                                <Icofont icon="user" style={{ fontSize: "13px" }} /> {t("Профиль")}
                            </a>
                        </List.Item> */}
                                                    </List>
                                                </div>
                                            </div>
                                        </div>
                                    </Content>
                                    {/* <Footer style={{ textAlign: 'center', fontSize: "12px" }}>
                                        Общероссийская физкультурно-спортивная общественная организация "Всероссийская федерация социальных танцев"
                                    </Footer> */}
                                </Layout>
                            </LangSwitchContext.Provider>
                        </LanguageContext.Provider>
                    </UserConfigContext.Provider>
                </UserContext.Provider>
            </MetaContext.Provider>
        </TranslateContext.Provider>)
}

function SwitchByID(props) {
    let navigate = useNavigate();
    let { id } = useParams();
    const auth = useAuth();

    const [event, setEvent] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id) {
            GET(auth, "/api/meropriyatiya/list/com?detail=model&w-id=" + id,
                ({ data }) => {
                    if (data && data.length) {
                        setEvent(data[0]);
                    }
                    setLoading(false);
                }, (err) => errorCatch(err, () => setLoading(false)));
        }
    }, [id])

    return (<React.Fragment>
        {loading && <Spin
            indicator={
                <LoadingOutlined
                    style={{
                        color: "grey",
                        fontSize: 12,
                    }}
                    spin
                />
            }
        />}
        {(!loading && event) && <Switcher event={event} />}
    </React.Fragment>)
}
function SwitchAll(props) {
    let navigate = useNavigate();
    const auth = useAuth();

    // var nurl = new URL(window.location.href);
    // var refUrl = nurl.searchParams.get("service");
    const t = (key) => key
    return (<Switcher />)
}
export default function AppSwitch(props) {
    let navigate = useNavigate();
    const auth = useAuth();

    return (<Routes>
        <Route path=":id" element={<SwitchByID />} />
        <Route path="*" element={<SwitchAll />} />
    </Routes>)
}